import { IEventTickets } from "interfaces";
import { abbreviateNumbers, currencySymbol, formatNumber } from "utills/helpers";

interface EventTicketsCardProps {
  data?: IEventTickets[];
  pageSize: number;
  currentPage: number;
  isLoading: boolean;
  currency?: string;
}

export const EventTicketsCard = ({data = [], pageSize = 10, currentPage = 1, isLoading, currency }: EventTicketsCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((item: IEventTickets, index: number) => (
        <div key={index} className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl">
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              No
            </p>
            <p className="flex-1 text-right text-sm leading-6">{(currentPage - 1) * pageSize + 1 + index}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Ticket Name
            </p>
            <p className="flex-1 text-right text-sm leading-6">{item.name_en}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Phase
            </p>
            <p className="flex-1 text-right text-sm leading-6">{item.ticket_phase_name_en}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Price
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.price)}
            >
              {currencySymbol(currency)} {abbreviateNumbers(item.price)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Items
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.quantity)}
            >
              {abbreviateNumbers(item.quantity)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Gross revenue
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.gross_revenue)}
            >
              {currencySymbol()} {abbreviateNumbers(item.gross_revenue)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Discount
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.discount_amount)}
            >
              {currencySymbol()} {abbreviateNumbers(item.discount_amount)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Net revenue
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.net_revenue)}
            >
              {currencySymbol()} {abbreviateNumbers(item.net_revenue)}
            </p>
          </li>
        </div>
      ))}
    </ul>
  )
}